import { PracticeFunction } from "app/models/practice"
import { createSelector } from "reselect"
import { capitalizeWord } from "utils"
import State from "../state"

export const loading = (state: State): boolean => state.functions.loading
export const getFunctions = (state: State): PracticeFunction[] => state.functions.data || []
export const getFunctionsAsOptions = createSelector(getFunctions, functions =>
  functions.map(fn => ({
    label: capitalizeWord(fn.name),
    value: fn.name,
  })),
)
export const getFunction = (state: State): PracticeFunction | undefined => state.functions.function
